import { ForumsPages } from "./ForumsPages";
import { ForumPage } from "./ForumPage";
import { ForumComments } from "./ForumComments";

const pages = {
  ForumsPages,
  ForumPage,
  ForumComments,
};
export default pages;
